import { render } from "./CardUserDashMain.vue?vue&type=template&id=568aee04&scoped=true"
import script from "./CardUserDashMain.vue?vue&type=script&lang=js"
export * from "./CardUserDashMain.vue?vue&type=script&lang=js"

import "./CardUserDashMain.vue?vue&type=style&index=0&id=568aee04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568aee04"]])

export default __exports__